// extracted by mini-css-extract-plugin
export default {"stock-audit-report-container":"StockAuditReport_stock-audit-report-container__G24ju"};